
























































































import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "./GGGroup/GGGroup.vue";
import GGRowSlider from "../grid-generation/GGRowSlider/GGRowSlider.vue";
import GGSaleCard from "./GGSaleCard.vue";
import ViewportToogle from "../ViewportToogle.vue";
import getValueForProp from "../../helper/getValueForProp";
import type { Sale } from "@constructor/shared-entity/type";
import type { PageData } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGSaleGrid",
  components: {
    GGGroup,
    GGRowSlider,
    GGSaleCard,
    ViewportToogle,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  computed: {
    list() {
      const value = getValueForProp(
        "filterSalesByIds",
        this.data.template.prop
      );
      const list = this.data.dataSource.data.sale || [];
      if (value) {
        const ids = value.split(",").map((id) => id);
        return list.filter((el) => ids.some((id) => id === el.id));
      }

      return list;
    },
    gridType() {
      return getValueForProp("saleGridType", this.data.template.prop);
    },
    length() {
      return this.list.length;
    },
    rows() {
      const splitBy = this.gridType === "2x3" ? 3 : 6;

      const rows = this.splitArray(splitBy);

      if (rows[0].length >= 3 && !!rows[1].length) {
        return rows;
      } else {
        return this.splitArray(3);
      }
    },
  },
  methods: {
    splitArray(lastItemsCount: 3 | 6): Sale[][] {
      const array = [...this.list];

      if (lastItemsCount >= array.length) {
        return [array, []];
      }

      const firstPart = array.slice(0, -lastItemsCount);
      const lastPart = array.slice(-lastItemsCount);

      return [firstPart, lastPart];
    },
  },
});
